module.exports = import("https://cdn.skypack.dev/@antmedia/webrtc_adaptor@SNAPSHOT");;